export default __webpack_public_path__ + "static/media/031-band-aid.237dcb28.png";